import { gql } from 'urql';

export const PayOverTimeTransactionAnalyticsFragment = gql`
  fragment PayOverTimeTransactionAnalyticsFragment on TransactionRowComponent {
    onClick {
      ... on TransactionDetailsNavigationAction {
        transaction {
          value {
            amount
          }
          ... on DebitCardTransaction {
            merchant {
              name
            }
            payOverTime {
              status
            }
          }
        }
      }
    }
  }
`;
